import "./PoolDeckContractors.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Introduction from "./sections/Introduction";
import Process from "./sections/Process";
import SubscribeForUpdates from "./sections/SubscribeForUpdates";
import Footer from "@/reusable_sections/Footer";
export default function PoolDeckContractorsPage() {
  return <div>
      <Header />
      <Hero />
      <Introduction />
      <Process />
      <SubscribeForUpdates />
      <Footer />
    </div>;
}